import React from 'react';

import { useIntl } from '../../../../util/reactIntl';

import { NamedLink } from '../../../../components';

import css from './SectionListItemCta.module.css';

/**
 * "Har du klær du aldri bruker?" selling prompt, sitting between the Kjoler
 * carousel and the recently-listed one. A blush band with a headline and a
 * dark (Om oss-style) CTA to the create-listing flow. The secondary link to
 * the selling guide was removed at the client's request (Sept 2026) — one
 * band, one action; the guide is still linked from the footer.
 *
 * @returns {JSX.Element}
 */
const SectionListItemCta = () => {
  const intl = useIntl();

  return (
    <section className={css.root}>
      <h2 className={css.headline}>
        {intl.formatMessage({ id: 'SectionListItemCta.headline' })}
      </h2>
      <NamedLink className={css.cta} name="NewListingPage">
        {intl.formatMessage({ id: 'SectionListItemCta.cta' })}
      </NamedLink>
    </section>
  );
};

export default SectionListItemCta;
